import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import Services from '../Components/Services';
import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getServicesByClient} from '../Api/api';

const ConnexionPage = (): JSX.Element => {
  const intl = useIntl();
  const {isLoading, data: services} = useQuery<ListService[]>(['get-service-by-client'], () =>
    getServicesByClient('Connexion')
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CONNECTIONS'})}</PageTitle>
      <Services
        isLoading={isLoading}
        services={services}
        title={intl.formatMessage({id: 'MENU.CONNECTIONS.LINKS'})}
        enableRowDetail
      />
    </>
  );
};

export default ConnexionPage;
